import React from 'react'
import { Spinner } from '@enterprise-ui/canvas-ui-react'
import { COST_CHANGE_INSIGHTS_SUBMISSION_RESULTS } from '../../globalConfig/constants'
import { SubmissionRecord } from './SubmissionRecord'
import { TablePagination } from '../../globalComponents/TablePagination'

export const SubmissionRecordsTable = React.memo(
  ({
    submissionRecords,
    tcin,
    page,
    recordsPerPage,
    updatePage,
    updateRecordsPerPage,
  }) => {
    const submissionHeaders = [
      COST_CHANGE_INSIGHTS_SUBMISSION_RESULTS.SUBMITTED_ON.label,
      COST_CHANGE_INSIGHTS_SUBMISSION_RESULTS.COST_LOCATION_GROUP_TYPE.label,
      COST_CHANGE_INSIGHTS_SUBMISSION_RESULTS.VENDOR_ID.label,
      COST_CHANGE_INSIGHTS_SUBMISSION_RESULTS.APPROVAL_STATUS.label,
      COST_CHANGE_INSIGHTS_SUBMISSION_RESULTS.NEW_UNIT_COST.label,
      COST_CHANGE_INSIGHTS_SUBMISSION_RESULTS.START_DATE.label,
    ]

    const totalRecords = submissionRecords?.costChangeSubmissionHistory?.length
    const startIndex = (page - 1) * recordsPerPage + 1
    const endIndex = Math.min(startIndex + recordsPerPage - 1, totalRecords)
    const rowsToDisplay = submissionRecords?.costChangeSubmissionHistory?.slice(
      startIndex - 1,
      endIndex,
    )

    return (
      <>
        <div className="hesp-general-flex hc-fs-lg hc-mt-md">
          <div
            className="hesp-general-flex hesp-general-alignItemsCenter hesp-general-fullwidth"
            style={{ paddingLeft: '10px', paddingRight: '30px' }}
          >
            {submissionHeaders.map((header) => {
              return (
                <div
                  className="hesp-general-flex-grow hesp-general-centeredText"
                  key={`${header}-submission-table-header`}
                  style={{ flexBasis: 0 }}
                >
                  {header}
                </div>
              )
            })}
          </div>
        </div>

        {submissionRecords?.isLoading ? (
          <div
            className="hesp-general-flex hesp-general-alignItemsCenter hesp-general-justifyCenter"
            style={{ height: '350px' }}
          >
            <Spinner size="expanded" />
          </div>
        ) : submissionRecords?.costChangeSubmissionHistory?.length ? (
          <div
            className="hesp-general-flex"
            style={{
              flexDirection: 'column',
              overflowY: 'scroll',
              maxHeight: '310px',
            }}
          >
            {rowsToDisplay.map((record, index) => (
              <SubmissionRecord
                key={`${tcin}-submission-record-${index}`}
                recordData={record}
              />
            ))}
          </div>
        ) : (
          <div
            className="hesp-general-flex hesp-general-alignItemsCenter hesp-general-justifyCenter"
            style={{ height: '350px' }}
          >
            <p>
              No submission records matching the provided filter criteria were
              found
            </p>
          </div>
        )}

        <TablePagination
          className="hc-mt-xs"
          dataTestId={`cost-change-insights-record-pagination ${tcin}`}
          currentPage={page}
          totalRecords={totalRecords}
          recordsPerPage={recordsPerPage}
          onRequestNext={() => updatePage(tcin, page + 1)}
          onRequestPrev={() => updatePage(tcin, page - 1)}
          onRequestFirst={() => updatePage(tcin, 1)}
          onRequestLast={() =>
            updatePage(tcin, Math.ceil(totalRecords / recordsPerPage))
          }
          onRequestPage={(page) => updatePage(tcin, page)}
          onRequestRecordsPerPage={(recordsPerPage) =>
            updateRecordsPerPage(tcin, recordsPerPage)
          }
          recordsPerPageOptions={[10, 25, 50]}
        />
      </>
    )
  },
)
